import React, { useState } from "react";
import LinkItem from "../Helpers/LinkItem";
import UserNotFound from "../NotFound/UserNotFound";
import Logo from "../Helpers/Logo";

const DefaultTemplate = ({
  profileImage,
  backgroundImage,
  bio,
  profileName,
  user_data,
}) => {
  const [imageError, setImageError] = useState(false); // To handle image errors

  // Handle missing profile data
  if (!profileImage && !backgroundImage && !bio && !profileName) {
    return <UserNotFound />;
  }

  return (
    <div className="relative min-h-screen flex items-center justify-center">
      <div className="w-1/4 relative">
        {/* Builder area */}
        <div
          className="relative shadow-lg rounded-xl overflow-hidden bg-cover bg-center h-[100vh] lg:h-[90vh]"
          style={{
            backgroundImage: backgroundImage
              ? `url(${backgroundImage})`
              : "none",
          }}
        >
          {/* Loop through user_data and position elements based on x and y values */}
          {user_data.map((element) => {
            switch (element.type) {
              case "profileImage":
                return (
                  <div
                    key={element.id}
                    style={{
                      position: "absolute",
                      top: `calc(${element.y}px)`,
                      left: `calc(${element.x}px)`,
                      transform: "translate(-50%, -50%)", // Center the element
                    }}
                  >
                    <img
                      src={imageError ? <Logo /> : profileImage}
                      alt="Profile"
                      className="w-20 h-20 rounded-full"
                      onError={() => setImageError(true)} // Fallback on error
                    />
                  </div>
                );

              case "text":
                return (
                  <div
                    key={element.id}
                    style={{
                      position: "absolute",
                      top: `calc(${element.y}px)`,
                      left: `calc(${element.x}px)`,
                      color: element.customizations.textColor || "#000",
                      fontSize: element.customizations.fontSize || "16px",
                      transform: "translate(-50%, -50%)", // Center the element
                    }}
                  >
                    <h1>{element.customizations.text}</h1>
                  </div>
                );

              case "socialLink":
                return (
                  <div
                    key={element.id}
                    style={{
                      position: "absolute",
                      top: `calc(${element.y}px)`,
                      left: `calc(${element.x}px)`,
                      backgroundColor:
                        element.customizations.backgroundColor || "#ddd",
                      transform: "translate(-50%, -50%)", // Center the element
                    }}
                    className="p-2 rounded-lg"
                  >
                    <a
                      href={element.customizations.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {element.customizations.text}
                    </a>
                  </div>
                );

              default:
                return null;
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default DefaultTemplate;
